/**
 * ログイン情報
 */
export default {
  state: {
    // ログイン情報
    info: null
  },
  getters: {
    /**
     * ログイン有無
     */
    login_isLogin (state) {
      if (!state.info) {
        return false
      }
      if (state.info.certifyFlg !== true) {
        return false
      }
      return true
    },
    /**
     * ユーザー種別
     */
    login_kind (state) {
      if (!state.info) {
        return false
      }
      if (state.info.userKind === null || state.info.userKind === undefined) {
        return null
      }
      return state.info.userKind
    }
  },
  actions: {
  },
  mutations: {
    /**
     * ログイン情報
     */
    login_info (state, value) {
      state.info = value
    }
  }
}
